import React, { createContext, ReactNode, FC, useContext, useState } from 'react'
import { Scalars } from 'types/graphqlTypes'
import { TCurrentFilters } from './types'

const ITEMS_PER_PAGE = 16

export const TrailerManagementContext = createContext<{
  currentFilters: TCurrentFilters
  setCurrentFilters: (filters: TCurrentFilters) => void
  itemsPerPage: number
  carrierId: Scalars['ID']
}>({
  currentFilters: {},
  setCurrentFilters: () => {},
  itemsPerPage: ITEMS_PER_PAGE,
  carrierId: '',
})

export const TrailerManagementContextProvider: FC<{ children: ReactNode; carrierId: string }> = ({
  carrierId,
  children,
}) => {
  const [currentFilters, setCurrentFilters] = useState<TCurrentFilters>({ first: ITEMS_PER_PAGE })

  return (
    <TrailerManagementContext.Provider
      value={{
        currentFilters,
        setCurrentFilters,
        itemsPerPage: ITEMS_PER_PAGE,
        carrierId,
      }}>
      {children}
    </TrailerManagementContext.Provider>
  )
}

export const useTrailerManagementContext = () => useContext(TrailerManagementContext)
